/* global Swiper:false */
/* eslint-disable */

(function () {
	"use strict";


	var container = document.querySelector(".kp-searchbar");
	var clientInfoContainers = document.querySelectorAll(".q-thumbnails-container");

	//<!--The event 'kpoint-search-result-shown' gets triggered when search results are shown//-->
	container.addEventListener("kpoint-search-result-shown", function (e) {
		[].forEach.call(clientInfoContainers, function(clientInfoContainer) {
			// hide static thumbnail containers
			clientInfoContainer.style.display = "none";
		});
	});

	//<!--The event 'kpoint-search-result-cleared' gets triggered when search results are cleared by clicking on the cross icon present in the searchbar//-->
	container.addEventListener("kpoint-search-result-cleared", function (e) {
		[].forEach.call(clientInfoContainers, function(clientInfoContainer) {
			// show static thumbnail containers
			clientInfoContainer.style.display = "block";
		});
	});

	//<!--This is used to embed the parameter at the end of Js File to burst the cache everytime the page load//-->
    var currentTimestamp = Date.now();
	var scriptElement = document.getElementById("kp-search-embed-code");
	scriptElement.src = scriptElement.src + "?ts=" + currentTimestamp;


	new Swiper(".q-active-resources-featured__container", {
		slidesPerView: "auto",
		centeredSlides: false,
		navigation: {
			nextEl: "#attend-live-next",
			prevEl: "#attend-live-prev",
			disabledClass: "q-carousel-button--disabled"
		},
		spaceBetween: 30
	});
	new Swiper(".best-practices", {
		slidesPerView: "auto",
		centeredSlides: false,
		grabCursor: true,
		navigation: {
			nextEl: "#best-practices-next",
			prevEl: "#best-practices-prev",
			disabledClass: "q-carousel-button--disabled"
		},
		spaceBetween: 10
	});

	new Swiper(".products-swiper-container", {
		slidesPerView: "auto",
		centeredSlides: false,
		grabCursor: true,
		navigation: {
			nextEl: "#product-demos-next",
			prevEl: "#product-demos-prev",
			disabledClass: "q-carousel-button--disabled"
		},
		spaceBetween:10
	});

	new Swiper(".cyber-risk-series-swiper-container", {
		slidesPerView: "auto",
		centeredSlides: false,
		grabCursor: true,
		navigation: {
			nextEl: "#cyber-risk-series-next",
			prevEl: "#cyber-risk-series-prev",
			disabledClass: "q-carousel-button--disabled"
		},
		spaceBetween:10
	});

	new Swiper(".workshop-wednesday-swiper-container", {
		slidesPerView: "auto",
		centeredSlides: false,
		grabCursor: true,
		navigation: {
			nextEl: "#workshop-wednesday-next",
			prevEl: "#workshop-wednesday-prev",
			disabledClass: "q-carousel-button--disabled"
		},
		spaceBetween:10
	});

	new Swiper(".on-demand-webinar-swiper-container", {
		slidesPerView: "auto",
		centeredSlides: false,
		grabCursor: true,
		navigation: {
			nextEl: "#on-demand-webinar-next",
			prevEl: "#on-demand-webinar-prev",
			disabledClass: "q-carousel-button--disabled"
		},
		spaceBetween:10
	});

	new Swiper(".qsc-keynotes-swiper-container", {
		slidesPerView: "auto",
		centeredSlides: false,
		grabCursor: true,
		navigation: {
			nextEl: "#qsc-keynotes-next",
			prevEl: "#qsc-keynotes-prev",
			disabledClass: "q-carousel-button--disabled"
		},
		spaceBetween:10
	});

	
	new Swiper(".testimonials", {
		slidesPerView: "auto",
		navigation: false,
		centeredSlides: false,
		spaceBetween: 10,
		grabCursor: true,
		breakpoints:{
			720 :{
				spaceBetween:30
			}
		}
	});



}());
